import PeerReview from "./components/PeerReview"
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Loading from "../common/Loading";
import ErrorPage from "../common/ErrorPage";
import PostcallTimer from "./components/PostCallTimer"

import './PostCall.css'
import FileSubmission from "./components/FileSubmission";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const PostCall = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true)
	const [error, setError] = useState(null)
	const [peerReviewError, setPeerReviewError] = useState(null)
	const [scoreLeft, setScoreLeft] = useState(100)

	const [data, setData] = useState(null)
	const [participants, setParticipants] = useState([])
	const [file, setFile] = useState(null)
	const [noFile, setNoFile] = useState(false)
	const [inconsistentSubmission, setInconsistentSubmission] = useState(null)

	let sent = false;
	let show = true;

	const UID = location.state.userUid
	const NAME = location.state.userName
	const NPM = location.state.userNpm
	const ROOM_ID = location.state.roomId

	const handlePeerReviewFormChange = (index, event) => {
		setPeerReviewError(null);
		let data = [...participants];
		let score = event.target.value;
		if (score < 0 || score > 100){
			score = 0
		}
		data[index]['score'] = score;
		let totalScore = data.map(participant => 
			participant.score === undefined ||  
			participant.score === "" ? 0 : participant.score)
			.reduce((sum, score) => sum + parseFloat(score), 0)
		setScoreLeft(100-totalScore)
		setParticipants(data);
	}

	const handleFileChange = (event) => {
		setInconsistentSubmission(null)
		setFile(event.target.files[0])
	}

	const handleDeleteFile = (ref) => {
		setFile(null)
		ref.current.value = null;
	}

	const handleWarningTimerEnds = () => {
		if (show){
			show = false
			NotificationManager.warning(
				'This page will be closed', 'Warning', 5000);
		}
	}

	const handleAckChange = () => {
		setInconsistentSubmission(null)
		setNoFile(!noFile)
	}

	const submit = async () => {
		if(sent) {
			return
		}
		sent = true;
		let totalScore = participants.map(participant => participant.score === undefined || participant.score === "" ? 0 : participant.score)
		.reduce((sum, score) => sum + parseFloat(score), 0)

		let participantData = [...participants]

		if (totalScore < 100 && totalScore > 0) {
			let emptyScore = participantData.map((p,i) => {
				return p['score'] === undefined || p['score'] === "" ? i : undefined
			}).filter(i => i)

			if (emptyScore.length === 0){
				let diff = 100 - totalScore;
				let adder = diff/participantData.length
				participantData.forEach(p => {
					p['score'] = parseFloat(p['score']) + adder
				})
			} else {
				let avgScore = (100-totalScore)/emptyScore.length;
				emptyScore.forEach(idx => {
					participantData[idx]['score'] = avgScore
				})
			}
		}

		if (totalScore > 100) {
			let diff = totalScore - 100;
			let reducer = diff/participantData.length
			participantData.forEach(p => {
				p['score'] = p['score'] - reducer
			})
		}

		if (totalScore <= 0) {
			participantData.forEach(p => {
				p['score'] = 0
			})
		}

		participantData.forEach(p => {
			if(p['score'] === undefined || p['score'] === ""){
				p['score'] = 0
			}
		})

		const formData = new FormData();
		const config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}

		formData.append('uid_pengirim', UID)
		formData.append('id_ruang_diskusi', ROOM_ID)
		formData.append('file_hasil_diskusi', file)

		participantData.forEach(p => {
			formData.append('participants[]', JSON.stringify(p))
		})

		
		try {
			await axios.post('https://backend-ta-wiyata.herokuapp.com/postcall/', formData, config);
			navigate('/finish')

		} catch(error) {
			setError(error)
		}
	}

	const handleSubmitData = async (e) => {
		e.preventDefault()
		let totalScore = participants.map(participant => participant.score === undefined || participant === "" ? 0 : participant.score)
			.reduce((sum, score) => sum + parseFloat(score), 0)
		if (totalScore !== 100) {
			setPeerReviewError('Total score is not equal to 100!')
		}

		if (file === null && noFile === false){
			setInconsistentSubmission('Please choose either upload a file or checked the no submission acknowledgement')
		}

		if (totalScore !== 100 || (file === null && noFile === false)){
			return
		}

		submit()
	}

	useEffect(() => {
		window.history.forward();
	})

	useEffect(() => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/ruang-diskusi-data/${ROOM_ID}/`)
			.then(function (response) {
				setData(response.data.data)
				setParticipants(
					response.data.data.peserta.filter( peserta =>
						peserta['uid_peserta'] !== UID &&
						peserta['role_peserta'] !== "HOST"
					).map(peserta => {
						return ({
							...peserta,
							score: undefined
						})
					})
				)
				setIsLoading(false)
			})
			.catch((error) => {
				setError(error)
				setIsLoading(false)
			})
		
	}, [])

	return (
		<div className='post-call-page'>
			{isLoading && <Loading />}
			{ !isLoading && data !== null && 
				<>
					<div className="header-postcall">
						<PostcallTimer 
							time={data.sesi.waktu_akhir} 
							handleTimerEnds={submit}
							handleWarningTimerEnds={handleWarningTimerEnds} />
						<div class="profile-postcall">
							<p>{NAME}</p>
							<p>STUDENT</p>
							<p>{NPM}</p>
						</div>
					</div>
					

					<div className='post-call-body'>
						<PeerReview 
							participants={participants}
							handleChange={handlePeerReviewFormChange}
							error={peerReviewError}
							scoreLeft={scoreLeft}
							data={data['sesi']}
						/>
						<FileSubmission 
							handleSubmitData={handleSubmitData} 
							file={file}
							handleFileChange={handleFileChange}
							handleDeleteFile={handleDeleteFile}
							noFile={noFile}
							handleAckChange={handleAckChange}
							error={inconsistentSubmission}
						/>
					</div>
				</>
			}
			{
				!isLoading && error !== null && (
					<ErrorPage error={error} />
				)
			}
			<NotificationContainer/>
			
		</div>
	);
}
 
export default PostCall;